import React, { useEffect, useState } from "react";
import { Download, Eye, Mail } from "lucide-react";
import { api } from "@/lib/api";
import { Panel } from "@/components/portal/crm/kit";
import { ukDayTime } from "@/lib/time";
import "@/styles/deal-pitch.css";

const DOC = { company_check: "the company check", deal_pack: "the deal pack" };

const line = (x) => {
  if (x.action === "email") return [`${x.who} emailed ${DOC[x.doc]}`, `To ${(x.to || []).join(", ")} · ${x.via === "link" ? "as a tracked link" : "attached, with a tracked link"}`];
  if (x.action === "opened") return [`${x.who} opened ${DOC[x.doc]}`, "From the tracked link in the email"];
  return [`${x.who} downloaded ${DOC[x.doc]}`, x.role === "admin" ? "Connexis" : x.role === "lender" ? "Lender desk" : x.role === "referrer" ? "Introducer" : ""];
};

/** Every download, email and link opened for this case's PDFs — Connexis only. */
export function PdfLog({ leadId, doc, testId = "hub-pdf-log" }) {
  const [items, setItems] = useState(null);
  const [all, setAll] = useState(false);
  useEffect(() => {
    api.get(`/hub/leads/${leadId}/pdf-log`).then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, [leadId]);
  const rows = (items || []).filter((x) => !doc || x.doc === doc);
  return (
    <Panel title="Who's had it" sub="Every download, email and link opened — only Connexis sees this." testId={testId}>
      {items === null ? <p className="dp-fine" style={{ margin: 0 }}>Loading…</p> : rows.length === 0 ? (
        <p className="dp-fine" style={{ margin: 0 }} data-testid={`${testId}-empty`}>Nobody has downloaded or sent {doc ? DOC[doc] : "anything"} yet.</p>
      ) : (
        <ul className="dp-log">
          {(all ? rows : rows.slice(0, 8)).map((x) => {
            const [a, b] = line(x);
            return (
              <li key={x.id} data-testid={`${testId}-row-${x.id}`}>
                <span className={`ic ${x.action === "email" ? "mail" : x.action === "opened" ? "open" : ""}`}>
                  {x.action === "email" ? <Mail className="size-4" /> : x.action === "opened" ? <Eye className="size-4" /> : <Download className="size-4" />}
                </span>
                <span style={{ minWidth: 0 }}><b>{a}</b><small>{[b, ukDayTime(x.at)].filter(Boolean).join(" · ")}</small></span>
              </li>
            );
          })}
        </ul>
      )}
      {rows.length > 8 && !all && (
        <button type="button" className="dp-add" style={{ marginTop: 10 }} onClick={() => setAll(true)} data-testid={`${testId}-all`}>
          Show all {rows.length}
        </button>
      )}
    </Panel>
  );
}
